const GCLID_KEY = 'propertymcp_gclid';
const GCLID_TIMESTAMP_KEY = 'propertymcp_gclid_timestamp';
const GCLID_EXPIRY_DAYS = 90;

export function captureGclid(): void {
  if (typeof window === 'undefined') return;

  const urlParams = new URLSearchParams(window.location.search);
  const gclid = urlParams.get('gclid');

  if (gclid) {
    try {
      localStorage.setItem(GCLID_KEY, gclid);
      localStorage.setItem(GCLID_TIMESTAMP_KEY, Date.now().toString());
    } catch (error) {
      console.error('[GCLID] Failed to store:', error);
    }
  }
}

export function getStoredGclid(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const gclid = localStorage.getItem(GCLID_KEY);
    const timestamp = localStorage.getItem(GCLID_TIMESTAMP_KEY);

    if (!gclid || !timestamp) {
      return null;
    }

    const age = Date.now() - parseInt(timestamp, 10);
    const maxAge = GCLID_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

    if (age > maxAge) {
      localStorage.removeItem(GCLID_KEY);
      localStorage.removeItem(GCLID_TIMESTAMP_KEY);
      return null;
    }

    return gclid;
  } catch (error) {
    console.error('[GCLID] Failed to retrieve:', error);
    return null;
  }
}

export function clearStoredGclid(): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(GCLID_KEY);
    localStorage.removeItem(GCLID_TIMESTAMP_KEY);
  } catch (error) {
    console.error('[GCLID] Failed to clear:', error);
  }
}

export function sendGclidToAnalytics(gclid: string | null): void {
  if (typeof window === 'undefined' || !gclid) return;

  // Published to the dataLayer rather than gtag('config', '<measurement-id>').
  // GA4 lives in the GTM container, so the measurement ID is deliberately not
  // known here — read this in GTM as a Data Layer Variable named `gclid`.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'gclid_captured', gclid });
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}
